// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2YGfj","label":"Category_label__20knd","content":"Category_content__uOrQz","header":"Category_header__2EqWS","location":"Category_location__Z-jzC"};